
import { defineComponent, computed } from 'vue'
import store from '@/store'

export default defineComponent({
  components: {},
  props: {
    hideOverlay: Boolean,
    showCloseButton: Boolean,
    hidePanelHead: Boolean,
  },
  setup() {
    const loading = computed(() => store.state.loading)
    return {
      loading,
    }
  },
})
